{
  "assets-deeplinking-modal.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "assets-deeplinking-modal.description1": [
    {
      "type": 0,
      "value": "You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the “Ticket volume” chart, we’ll open a detailed view showing the actual tickets that make up that data point."
    }
  ],
  "assets-deeplinking-modal.description2": [
    {
      "type": 0,
      "value": "This lets you move from high-level trends to the raw sources behind them in just one click."
    }
  ],
  "assets-deeplinking-modal.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "assets-deeplinking-modal.heading": [
    {
      "type": 0,
      "value": "See the data behind your charts"
    }
  ],
  "jira-ops-reports-changeboarding.close-button": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-ops-reports-changeboarding.done-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "jira-ops-reports-changeboarding.feature1": [
    {
      "type": 0,
      "value": "Add views as tabs to organize information your way"
    }
  ],
  "jira-ops-reports-changeboarding.feature2": [
    {
      "type": 0,
      "value": "Create new charts to meet your custom needs."
    }
  ],
  "jira-ops-reports-changeboarding.heading": [
    {
      "type": 0,
      "value": "Your new reporting experience"
    }
  ],
  "jira-ops-reports-changeboarding.more-about-reports-button": [
    {
      "type": 0,
      "value": "More about reports"
    }
  ],
  "jira-ops-reports-changeboarding.subtitle": [
    {
      "type": 0,
      "value": "Tailor your reports by adding tabs, widgets, charts and editing filters."
    }
  ],
  "jira-ops-reports-changeboarding.whats-new-heading": [
    {
      "type": 0,
      "value": "What’s new?"
    }
  ]
}